/**
Information on subclasses:

Subclasses MAY set these properties:
this.overlayId = 'abc'                      - sets the overlay id to 'abc' (default: none)
**/
(function(){
  'use strict';

  var helper = require('../helpers/generic.js');
  var $ = require('jquery');
  var imagesLoaded = require('imagesloaded');
  imagesLoaded.makeJQueryPlugin( $ );
  var logger = new (require('../helpers/logger.js'))("Generic VideoPlayer").setColor("#de7ddd").setDebug(true);
  var Overlay = require('../Overlay/main.js');

  module.exports = VideoPlayer;

  var defaultOptions = {
    posterSize: 'cover',
    overlayAutoScale: true,
    forcePosterDimensions: false,
    omitPosterElement: false,
    inheritMaxWidthFrom: null // one may define a selector like ("#main"); The elements width is used to set the maxWidth for the videoContainer (inline videos only); listens to window.onResize
  };

  function VideoPlayer(mediaInstance, inline, container, posterImageUrlOrMedia, defaultQuality, defaultsOverride, options, playButtonImage, playButtonHoverImage){
    var self = this;
    this.media = mediaInstance;
    this.inline = inline;
    this.options = jQuery.extend(true, {}, defaultOptions);
    this.defaultQuality = defaultQuality;
    this.baseContainer = $(container);
    this.baseContainer.data("cmy-videoplayer", this);
    if (!helper.undefOrNull(defaultsOverride)){
      this.modifyOptionsWith(defaultsOverride);
    }
    if (!helper.undefOrNull(options)){
      this.modifyOptionsWith(options);
    }

    this.poster = posterImageUrlOrMedia;

    var plyId = "ply-" + new Date().getTime(); //jwPlayer needs individual IDs to be able to display more than one instance at a time
    this._containerId = plyId;
    if (inline){
      this.container = $(container);
      if (helper.undefOrNull(this.container.attr("id"))){ //if the element has no id, use the generated one to be able to display more than one instance at a time
        this.container.attr("id", plyId);
      } else {
        this._containerId = this.container.attr("id").replace("#","");
      }
    }

    // check if we should inherit the max width from a configured Element
    if (!helper.undefOrNull(self.options.inheritMaxWidthFrom) && $(self.options.inheritMaxWidthFrom).length>0){
      //TODO: Check; Do we need to clean-up the onResize event on unload?
      self.inheritContainerWidth(false);
      $(window).on('resize', function(){ self.inheritContainerWidth(false, self); });
    }

    if (!helper.undefOrNull(playButtonImage)){
      this._addPlayButton(playButtonImage, playButtonHoverImage);
    }

    logger.debug("initting VideoPlayer with options (overlay: "+(!inline)+", overlayAutoscale: "+(this.options.overlayAutoScale)+", poster: "+((helper.undefOrNull(posterImageUrlOrMedia) || helper.undefOrNull(posterImageUrlOrMedia.json))?posterImageUrlOrMedia:posterImageUrlOrMedia.json.code)+", playButton: "+playButtonImage+", provider: "+this.media.provider()+"); baseContainer: ", this.baseContainer);
  }

  VideoPlayer.prototype = {
    _play: function _play(){
      throw "You either called _play() on the SuperClass or your SubClass does not implement the _play()-Method! This is unsupported!";
    },
    _onClose: function _onClose(){
      if (!helper.undefOrNull(this.__resizeFunction)){
        $(window).off('resize', this.__resizeFunction);
      }
      for (var prop in this) {
        if (this.hasOwnProperty(prop)) {
          logger.debug("setting null: "+prop);
          prop = null;
        }
      }
    },
    _onResize: function _onResize(){
      var self = this;

      var doResize = function doResize(self, givenWidth, givenHeight, newWidth, newHeight){
        var width = typeof newWidth != "undefined" && newWidth !== null ? newWidth : givenWidth;
        var height = typeof newHeight != "undefined" && newHeight !== null ? newHeight : givenHeight;
        var viewHeight = $(window).height();
        var viewWidth = $(window).width();
        var posTop = self.overlay.position().top;
        var ratio = height / width;
        var closeButtonWidth = self.overlay.getCloseButton() !== null ? (self.overlay.getCloseButton().width()-parseInt(self.overlay.getCloseButton().css('right'))) : 0;
        var viewIsLessHigh = viewHeight < (posTop + height);
        var viewIsLessWide = viewWidth < (width+closeButtonWidth*2);
          //do actual resizing
        if (viewIsLessHigh){
          newHeight = viewHeight-posTop;
          newWidth = newHeight / ratio;
          doResize(self, givenWidth, givenHeight, newWidth, newHeight);
          return;
        } else if (viewIsLessWide){
          newWidth = viewWidth - closeButtonWidth*2;
          newHeight = newWidth * ratio;
          doResize(self, givenWidth, givenHeight, newWidth, newHeight);
          return;
        }
        self.overlay.resizeContent(width, height);
        self.resizeForOverlay(width, height); // call child function
      };

      if (!this.inline && this.options.overlayAutoScale){
        doResize(this, this.media.width(this.defaultQuality), this.media.height(this.defaultQuality));
      }
    },
    _addPlayButton: function(url, hoverUrl){
      if (!helper.undefOrNull(url)){
        var container = this.baseContainer;

        var conPos = container.css('position');
        if (conPos == 'static' || !conPos.length){
          container.css('position', 'relative');
        }

        var $btn = $("<img src='"+url+"' />");


        /*
         * TODO: FIXME: When prepending the button
         * the container looses its css width and height properties somehow
         * (we do not know why, yet);
         *
         * So for a temporary fix, we read those values, check if they're validateForm
         * and set them again after the button was prepended
         */
        var width = container.css("width");
        var height = container.css("height");
        container.prepend($btn);
        if (width.endsWith("px") && height.endsWith("px")){
          container.css({width: width, height: height});
        }

        if (!helper.undefOrNull(hoverUrl)){
          container.hover(function(){
            $btn.attr("src", hoverUrl);
          }, function(){
            $btn.attr("src", url);
          });
        }

        $btn.imagesLoaded(function(){
          $btn.css({
            position : 'absolute',
            left : '50%',
            top : '50%',
            marginLeft : -$btn.outerWidth()/2,
            marginTop : -$btn.outerHeight()/2
          });
        });

      }
    },
    posterUrl: function posterUrl(){
      var poster = this.poster;
      if (helper.undefOrNull(poster)){
        return null;
      }

      var url;
      if (poster.constructor.name == "String" || typeof poster == "string"){ //2nd clause is needed for IE
        logger.debug("Poster is URL: ", poster);
        url = poster;
      } else { // NOTE: using constructor.name may return incorrect results in minified javascripts! (e.g. 'AssetCoreMedia'=='t')
          url = poster.dppxUrl();
      }

      return url;
    },
    _initPoster: function _initPoster(){
      var poster = this.poster;
      if (helper.undefOrNull(poster)){
        return;
      }

      var self = this;
      var url = this.posterUrl();

      var container = this.baseContainer instanceof jQuery ? this.baseContainer : $(this.baseContainer);
      container.css({
        backgroundImage:'url('+url+')',
        backgroundSize:this.options.posterSize,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center center',
        cursor: 'pointer'
      });

      if (container.width() <= 0 || container.height() <= 0 || this.options.forcePosterDimensions){
        logger.debug("forcing poster dimensions on", container);
        if (helper.undefOrNull(poster.width)){ //is url
          container.imagesLoaded({ background: true }, function(ldr){
            if (ldr.images.length >= 1){
              var image = ldr.images[0];
              container.css({
                width: image.img.width,
                height: image.img.height
              });
            }
          });
        } else {
          container.css({
            width: poster.width(),
            height: poster.height()
          });
        }
        self.inheritContainerWidth(false, self);
      }

      logger.debug("poster '"+url+"' was set on container" + (this.options.forcePosterDimensions?" with forced poster-dimensions":""), container);
      container.click(function(){
        self._play();
      });
    },
    hasPoster: function hasPoster(){
      return !helper.undefOrNull(this.poster);
    },
    inheritContainerWidth: function inheritContainerWidth(enlarge, thisInstance){ //thisInstance is used for callbacks that otherwise would set this=window
      var self = helper.undefOrNull(thisInstance) ? this : thisInstance;
      if (helper.undefOrNull(this.options) || helper.undefOrNull(this.options.inheritMaxWidthFrom)){
        return;
      }
      var $el = $(this.options.inheritMaxWidthFrom);
      if (helper.undefOrNull($el)){
        logger.debug("wont' inherit container width as $el with selector ("+this.options.inheritMaxWidthFrom+") was not found");
      } else {
        var elWidth = $el.width();
        if (elWidth > 0){
          var ratio = this.media.ratio();
          if (!isNaN(ratio)){
            var height = elWidth / ratio;
            if ((height <= this.media.height(this.defaultQuality) && elWidth <= this.media.width(this.defaultQuality)) || enlarge){
              self.resizeForInheritation(elWidth, height);
              return [elWidth, height];
            } else {
              self.resizeForInheritation(self.media.width(self.defaultQuality), self.media.height(self.defaultQuality));
              return null;
            }
          }
        }
        return null;
      }
    },
    resizeForInheritation: function resizeForInheritation(width, height){
      logger.error("You either called resizeForInheritation() on the SuperClass or your SubClass does not implement the resizeForInheritation()-Method! This is unsupported!");
    },
    resizeForOverlay: function resizeForOverlay(width, height){
      logger.error("You either called resizeForOverlay() on the SuperClass or your SubClass does not implement the resizeForOverlay()-Method! This is unsupported!");
    },
    resize: function resize(width, height){
      logger.error("You either called resize() on the SuperClass or your SubClass does not implement the resize()-Method! This is unsupported!");
    },
    play: function play(){
      var self = this;
      var container = this.container;

      if (!this.inline){
        this.container = $("<div id='"+this._containerId+"'></div>");
        container = this.container;

        container.css({ width: this.media.width(this.defaultQuality), height: this.media.height(this.defaultQuality) });

        this.overlay = new Overlay(container).show();
        if (!helper.undefOrNull(this.overlayId)){
          container.attr("id", this.overlayId);
        }
        this.overlay.addRemovalCallback(function(){
          self._onClose();
        });
      }

      this._play(container);

      if (!this.inline && this.options.overlayAutoScale){
        // call resize once to fit the player into the browser window on init
        self._onResize();
        self.overlay.centerContent();

        this.__resizeFunction = function(){ self._onResize(); };
        $(window).on('resize', self.__resizeFunction);
      }
    },
    getMedia: function getMedia(){
      return this.media;
    },
    getContainer: function getContainer(){
      return document.getElementById(this._containerId);
    },
    modifyOptionsWith: function modifyOptionsWith(optionsObject){
      if (helper.undefOrNull(optionsObject) || $.isEmptyObject(optionsObject)){
        return;
      }
      $.extend( true, this.options, optionsObject );
      return this;
    }
  };

}());



//////////////////
// WEBPACK FOOTER
// ./src/VideoPlayer/videoplayer.js
// module id = 11
// module chunks = 0